import {XHTTP} from '@/shared/xhttp';
import {DevisElementsListService} from "@/xhttp/DevisElementsListService";
import {Devis} from "@/models/Devis";
import {Tva} from "@/models/Tva";

@XHTTP(DevisElementsListService, '/devis/elements')
export class DevisElementsList {

	private _id: number;
	private _reference: string;
	private _description: string;
	private _type: string;
	private _amount: number;
	private _quantity: number;
	private _discount: number;
	private _purchasePrice: number;
	private _devis: Devis;
	private _tva: Tva;
	private _createdAt: Date;

	/////////////
	// Getters //
	/////////////

	public get id(): number {
		return this._id;
	}

	public get reference(): string {
		return this._reference;
	}

	public get description(): string {
		return this._description;
	}

	public get type(): string {
		return this._type;
	}

	public get amount(): number {
		return this._amount;
	}

	public get quantity(): number {
		return this._quantity;
	}

	public get discount(): number {
		return this._discount;
	}

	public get purchasePrice(): number {
		return this._purchasePrice;
	}

	public get devis(): Devis {
		return this._devis;
	}

	public get tva(): Tva {
		return this._tva;
	}

	public get createdAt(): Date {
		return this._createdAt;
	}

	/////////////
	// Setters //
	/////////////

	public set reference(value: string) {
		this._reference = value;
	}

	public set description(value: string) {
		this._description = value;
	}

	public set type(value: string) {
		this._type = value;
	}

	public set amount(value: number) {
		this._amount = value;
	}

	public set quantity(value: number) {
		this._quantity = value;
	}

	public set discount(value: number) {
		this._discount = value;
	}

	public set purchasePrice(value: number) {
		this._purchasePrice = value;
	}

	public set devis(value: Devis) {
		this._devis = value;
	}

	public set tva(value: Tva) {
		this._tva = value;
	}

	///////////////
	// Serialize //
	///////////////+

	public toJSON(): any {
		return {
			id       : this._id,
			reference     : this._reference,
			description     : this._description,
			type  : this._type,
			amount  : this._amount,
			quantity  : this._quantity,
			discount  : this._discount ? this._discount : 0,
			purchasePrice  : this._purchasePrice ? this._purchasePrice : 0,
			devis  : this._devis ? this._devis.id : null,
			tva  : this._tva ? this._tva.id : null,
		};
	}

	public fromJSON(data: any): this {
		this._id        = data.id;
		this._reference      = data.reference;
		this._description      = data.description;
		this._type   = data.type;
		this._amount   = data.amount;
		this._quantity   = data.quantity;
		this._discount   = data.discount;
		this._purchasePrice   = data.purchasePrice;
		this._devis    = data.devis ? (new Devis()).fromJSON(data.devis) : null;
		this._tva    = data.tva ? (new Tva()).fromJSON(data.tva) : null;
		this._createdAt                  = data.createdAt ? new Date(data.createdAt) : null;
		return this;
	}
}